// extracted by mini-css-extract-plugin
export default {"container":"coo_3SYyx","row":"coo_row_3rZBw","label":"coo_lab_31NcH","title":"coo_tit_1bgDn","description":"coo_des_3eyMt","toggle":"coo_tog_r7LM2"};